import type { SeoContent } from 'types'
// CONSTANTS
export const Constants = {
  SET: 'SET_SEO_CONTENT',
  SET_PAGE: 'SET_SEO_CONTENT_PAGE',
}
// ACTION TYPES
export type FlowTypes =
  | {
      type: typeof Constants.SET
      payload: SeoContent
    }
  | {
      type: typeof Constants.SET_PAGE
      payload: SeoContent
    }
// ACTION CALLS
export const Actions = {
  SET: (payload: SeoContent): FlowTypes => ({
    type: Constants.SET,
    payload,
  }),
  SET_PAGE: (payload: SeoContent): FlowTypes => ({
    type: Constants.SET_PAGE,
    payload,
  }),
}